import * as React from "react";

function SvgIcUsageRetired(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.969 17.062c.28.555.988.689 1.503.34.516-.347.642-1.044.385-1.61a6.747 6.747 0 01-.562-2.042H6a.75.75 0 000-1.5h-.705a6.748 6.748 0 011.433-3.461l.449.448a.75.75 0 101.06-1.06l-.448-.449a6.746 6.746 0 013.461-1.433V7a.75.75 0 001.5 0v-.705a6.747 6.747 0 013.528 1.487l-.394.395a.75.75 0 101.06 1.06l.381-.38a6.744 6.744 0 011.38 3.393H18a.75.75 0 000 1.5h.706a6.748 6.748 0 01-.583 2.084c-.261.564-.14 1.263.374 1.614.513.352 1.221.223 1.506-.33a9 9 0 10-16.034-.056zM12 14a1 1 0 10-.992-.874L8.509 15.79a.149.149 0 00.189.227l3.158-2.028c.047.006.095.01.144.01z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcUsageRetired;
